import {Sized, Widget} from "./widgets";
import {Integrations} from "./integrations";
import {LightboxActionModel} from "./actions";

type ObjectId = string;

interface ExperienceGroup {
    resourceId: string;
    resourceType: string;
}

export interface Experience extends Sized {
    id: ObjectId;
    companyId: ObjectId;
    name: string;
    scenes: ReadonlyArray<SceneModel>;
    overlayScene: SceneModel;
    backgroundScene: SceneModel;
    group: ExperienceGroup;
    backdrop: Backdrop;
    transition: SceneTransitionType;
    integrations?: ReadonlyArray<Integrations>;
    lightbox?: LightboxActionModel;
    type?: string; // group data that ideally shouldn't be passed to Experience
    autoPlayDelay: number;
}

export type ExperienceModel = Readonly<Experience>;

interface Scene {
    id: string;
    sceneNumber: "overlay" | "background" | string; // unfortunately, numbers are stored as strings here
    widgets: ReadonlyArray<Widget>;
    openLightbox?: () => void;
}
export type SceneModel = Readonly<Scene>;

export const enum BackdropTypes {
    COLOR = "color",
    IMAGE = "Image"
}

interface BaseBackdrop {
    type: BackdropTypes;
    fit: "Experience" | "Container";
    color: string;
}

interface ColorBackdrop extends BaseBackdrop {
    type: BackdropTypes.COLOR;
}
interface ImageBackdrop extends BaseBackdrop {
    type: BackdropTypes.IMAGE;
    image: Readonly<{
        id: ObjectId;
        version: number;
        companyId: ObjectId;
        name: string;
        altText: string;
        url: string;
        thumbUrl: string;
        size: number;
        width: number;
        height: number;
        supportsResize: boolean;
        timesUsed: number;
    }>;
}

export type Backdrop = Readonly<ColorBackdrop | ImageBackdrop>;

export type VariantGroupModel = Readonly<{
    id: string,
    entries: ReadonlyArray<Readonly<VariantGroupEntry>>;
}>;

export interface VariantGroupEntry {
    value?: Readonly<{threshold: number}>;
    reference: Readonly<{resourceId: string}>;
    type: VariantEntityType;
}

export enum VariantEntityType {
    BREAKPOINT = "Breakpoint",
    LOCALIZATION = "Localization",
}

export interface VariantEntry {
    resourceId: string;
    type: VariantEntityType;
}

export interface BreakpointEntry extends VariantEntry {
    threshold: number;
}

interface AnalyticsEvent {
    companyId: string;
    experienceId: string;
    experienceName: string;
}

export type AnalyticsEventModel = Readonly<AnalyticsEvent>;

export enum IconPlacementTypes {
    BEFORE = "before",
    AFTER = "after"
}

interface Icon {
    codepoint: string;
    color: string;
    groupId: string;
    iconId: string;
    ligature: string;
    name: string;
    placement: IconPlacementTypes;
    size: number;
}

export type IconModel = Readonly<Icon>;

export enum ButtonWidgetTypes {
    TEXT_ONLY = "TEXT_ONLY",
    ICON_ONLY = "ICON_ONLY",
    TEXT_AND_ICON =  "TEXT_AND_ICON"
}

export type FontStyleType = "initial" | "inherit" | "unset" | "normal" | "italic" | "oblique" | undefined;
export type FontWeightType = "initial" | "inherit" | "unset" | "normal" | "bold" | "bolder" |
    "lighter" | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | undefined;

export enum SceneTransitionType {
    NONE = "none",
    SLIDE_FROM_TOP = "slide-from-top",
    SLIDE_FROM_BOTTOM = "slide-from-bottom",
    SLIDE_FROM_LEFT = "slide-from-left",
    SLIDE_FROM_RIGHT = "slide-from-right",
    FADE = "fade"
}



// WEBPACK FOOTER //
// ./src/shared/xp/models/interfaces.ts